__turbopack_context__.v({
  "body": "SendConfirmationCard-module__xzhBcG__body",
  "card": "SendConfirmationCard-module__xzhBcG__card",
  "footer": "SendConfirmationCard-module__xzhBcG__footer",
  "header": "SendConfirmationCard-module__xzhBcG__header",
  "hint": "SendConfirmationCard-module__xzhBcG__hint",
  "label": "SendConfirmationCard-module__xzhBcG__label",
  "row": "SendConfirmationCard-module__xzhBcG__row",
});
